import './ItemPager.scss';

import React, { FC, useState } from 'react';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';

interface ItemPagerProps {
  viewAllLink?: string;
  numberItemsPerPage: number;
  totalNumberEntries?: number;
  onChangePageNumber: (pageNumber: number, skip: number) => void;
}

const ItemPager: FC<ItemPagerProps> = ({viewAllLink, numberItemsPerPage, totalNumberEntries, onChangePageNumber}) => {
  let numberPages: number;
  if (!totalNumberEntries) {
    numberPages = 0;
  }
  else if (totalNumberEntries > numberItemsPerPage) {
    numberPages = Math.ceil(totalNumberEntries / numberItemsPerPage);
  } else {
    numberPages = 0;
  }
  const pageNumbers = Array.from({ length: numberPages }, (_, index) => index+1);
  const [currentPage, setCurrentPage] = useState(1);

  const changePage = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    const skip = numberItemsPerPage * (pageNumber-1);
    if (onChangePageNumber) {
      onChangePageNumber(pageNumber, skip);
    }
  };

  if (numberPages === 0) {
    return (
      <Row className="item-pager my-1">
        <Col sm style={{ textAlign: 'right'}}>
          <Button variant="link" href={viewAllLink} target="_blank" rel="noreferrer">All</Button>
        </Col>
      </Row>
    );
  }


  return (
  <Row className="item-pager my-1">
    <Col sm style={{ textAlign: 'right'}}>
      <ButtonGroup aria-label="prompt chain pager">
        <Button 
          variant="light"
          onClick={() => changePage(currentPage-1)}
          disabled={currentPage === 1}>
            Back
        </Button>
        {pageNumbers.map((p) => (
          <Button 
            key={p}
            variant="light" 
            onClick={() => changePage(p)} 
            disabled={currentPage === (p)}>
              {p}
          </Button>
        ))}
        <Button 
          variant="light"
          onClick={() => changePage(currentPage+1)}
          disabled={currentPage === numberPages}>
            Next
        </Button>
      </ButtonGroup>
      <Button variant="link" href={viewAllLink} target="_blank" rel="noreferrer">All</Button>
    </Col>
  </Row>
)};

export default ItemPager;
